export default __webpack_public_path__ + "static/media/filling_10.3d87bd0e.jpg";